export const PENDING_PLAY_POST_ACTIONS = {
    QUICK_DEPOSIT: '7',
    CLOSE: 'pending'
}